import Rules from './baseRules';
import Types from '../utils/type';

// 规则集合
export const defaultRules = {};

export const useRules = rules => {
    Object.keys(rules).forEach(item => {
        if (Types.array(rules[item])) {
            rules[item] = {
                rules: rules[item]
            };
        }
        if (Object.prototype.hasOwnProperty.call(defaultRules, item)) {
            defaultRules[item].rules = (defaultRules[item].rules || []).concat(rules[item].rules);
            defaultRules[item].trigger = (defaultRules[item].trigger || []).concat(rules[item].trigger);
            defaultRules[item].isWeak = defaultRules[item].isWeak || rules[item].isWeak;
        } else {
            defaultRules[item] = rules[item];
        }
    });
    return defaultRules;
};

useRules({
    skuId: [Rules.typeValid({ type: 'number' }), Rules.integerLen({ max: 20 }, '请输入小于20位的SKUID')],
    bankCard: [Rules.inLenList({ list: [16, 18, 19] })],
    priceF2: [Rules.decimalLen({ len: 2, isEqual: true }, '请输入2位小数价格')],
    priceF4: [Rules.decimalLen({ len: 4, isEqual: true }, '请输入4位小数价格')]
});
